module.exports = __webpack_public_path__ + "img/card-rp-requests-contracts-report.44c8777d.svg";